// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/home/dusan/Documents/Projects/abd.rs/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/home/dusan/Documents/Projects/abd.rs/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-page-2-js": () => import("/home/dusan/Documents/Projects/abd.rs/src/pages/page-2.js" /* webpackChunkName: "component---src-pages-page-2-js" */),
  "component---src-pages-viljuskari-pages-js": () => import("/home/dusan/Documents/Projects/abd.rs/src/pages/ViljuskariPages.js" /* webpackChunkName: "component---src-pages-viljuskari-pages-js" */)
}

